import type { SelectedAccountData, SessionUserData } from "./types/SessionUserData";

let sessionUser: SessionUserData = { roles: [] };
let selectedAccount: SelectedAccountData | null = null;
let showExclusivePack = false;
let sessionResolved = false;

export function setSessionRuntimeState(
  user: SessionUserData,
  account: SelectedAccountData | null,
  exclusivePack: boolean,
): void {
  sessionUser = { ...user, roles: [...user.roles] };
  selectedAccount = account ? { ...account } : null;
  showExclusivePack = exclusivePack;
  sessionResolved = true;
}

export function clearSessionRuntimeState(): void {
  sessionUser = { roles: [] };
  selectedAccount = null;
  showExclusivePack = false;
  sessionResolved = false;
}

export function getSessionUserSnapshot(): SessionUserData {
  return sessionUser;
}

export function getSessionSelectedAccount(): SelectedAccountData | null {
  return selectedAccount;
}

export function isSessionExclusivePackEnabled(): boolean {
  return showExclusivePack;
}

export function isSessionResolved(): boolean {
  return sessionResolved;
}
